import { useObservable } from '@logz-pkg/observable';
import { playgroundStateService } from '../playground.state.service';

export const usePlaygroundState = () => ({
  isPlayground: useObservable(playgroundStateService.isPlayground),
  setPlaygroundModalOpen: playgroundStateService.setPlaygroundModalOpen,
});
